export default {
  agents: [],
  agent: {},
  expenses: [],
  coupons: []
}
